import './index.css';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/core';
import { LocalizationProvider } from '@material-ui/lab';
import moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import theme from './theme';

// import reportWebVitals from './reportWebVitals';

const root = document.getElementById('alculator-root');

if (root) {
    try {
        require('moment/locale/' + document.documentElement.lang);
        moment.locale(document.documentElement.lang);
    } catch (e) {}

    ReactDOM.render(
        // <React.StrictMode>
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={MomentUtils} locale={document.documentElement.lang}>
                <App />
            </LocalizationProvider>
        </ThemeProvider>,
        // </React.StrictMode>,
        root
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
